export type ProductCategoryKeys = (typeof ProductCategoryKey)[keyof typeof ProductCategoryKey];

export const ProductCategoryKey: {
	readonly Confluence: 'confluence';
	readonly Atlas: 'atlas';
	readonly Jira: 'jira';
	readonly JiraServiceManagement: 'jira-servicedesk';
} = {
	Confluence: 'confluence',
	Atlas: 'atlas',
	Jira: 'jira',
	JiraServiceManagement: 'jira-servicedesk',
} as const;
